import * as React from 'react'
import * as PropTypes from 'prop-types'

import * as S from './styles.js'

class ModalBehaviour extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
    }
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 27 && this.props.isClosable) {
      this.handleCloseModal()
    }
  }

  handleOpenModal = () => {
    document.addEventListener('keydown', this.handleKeyDown)

    this.setState({
      isOpen: true,
    })
  }

  handleCloseModal = () => {
    if (this.state.isOpen) {
      document.removeEventListener('keydown', this.handleKeyDown)

      this.setState({
        isOpen: false,
      })

      if (this.props.onClosing && typeof this.props.onClosing === 'function') {
        this.props.onClosing()
      }
    }
  }

  componentDidMount = () => {
    if (this.props.isOpen) {
      this.handleOpenModal()
    }
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.handleOpenModal()
    } else if (!this.props.isOpen && prevProps.isOpen) {
      this.handleCloseModal()
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  render() {
    const { isClosable, overlay, children } = this.props
    const { isOpen } = this.state
    const ModalWrapper = this.props.wrapper

    return (
      <ModalWrapper isOpen={isOpen}>
        {overlay && <S.ModalOverlay isOpen={isOpen} onClick={isClosable ? this.handleCloseModal : undefined} />}
        {children({
          isOpen,
          onClickClose: this.handleCloseModal,
          onExited: this.handleOnExited,
        })}
      </ModalWrapper>
    )
  }
}

ModalBehaviour.defaultProps = {
  isOpen: false,
  overlay: true,
  isClosable: true,
  wrapper: S.ModalWrapper,
}

ModalBehaviour.propTypes = {
  isOpen: PropTypes.bool,
  overlay: PropTypes.bool,
  isClosable: PropTypes.bool,
  onClosing: PropTypes.func,
  children: PropTypes.func.isRequired,
  wrapper: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default ModalBehaviour
